module.exports = __webpack_public_path__ + "img/companyinfo.e813a400.png";